import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomBadge, {atomBadgeDesigns, atomBadgeSizes} from '@s-ui/react-atom-badge'
import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomCard from '@s-ui/react-atom-card'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import TitleBasic, {titleBasicSizes} from '@adv-mt/mt-title-basic'

export default function CardConfigurator({
  make,
  model,
  imageUrl,
  href,
  priceFrom,
  onConfiguratorClick,
  linkFactory: Link = 'a'
}) {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const isTabletOrWider = useMediaQuery(useMediaQueryBreakpoints.md, {
    defaultMatches: !isMobile
  })

  const handleConfiguratorClick = () => {
    onConfiguratorClick?.({make, model})
  }

  const media = () => <AtomImage className="mt-CardConfigurator-image" src={imageUrl} alt={`${make} ${model}`} />

  const content = () => (
    <div className="mt-CardConfigurator-content">
      <div className="mt-CardConfigurator-info">
        <div className="mt-CardConfigurator-title">
          <TitleBasic as="h3" size={titleBasicSizes.s} title={`${make} ${model}`} />
        </div>
        <div className="mt-CardConfigurator-details">
          <span className="mt-CardConfigurator-priceFrom">{i18n.t('COMMON_FROM')}</span>
          <span className="mt-CardConfigurator-price">
            <TitleBasic as="span" size={titleBasicSizes.s} title={priceFrom} />
          </span>
          <span className="mt-CardConfigurator-badge">
            <AtomBadge
              design={atomBadgeDesigns.SOFT}
              type="gray"
              size={atomBadgeSizes.LARGE}
              label={i18n.t('COMMON.NEW')}
            ></AtomBadge>
          </span>
        </div>
      </div>
      <div className="mt-CardConfigurator-buttonContainer">
        <AtomButton shape={atomButtonShapes.CIRCULAR} size={atomButtonSizes.MEDIUM} fullWidth={!isTabletOrWider}>
          {i18n.t('COMMON.CONFIGURE')}
        </AtomButton>
      </div>
    </div>
  )

  return (
    <div className="mt-CardConfigurator mt-CardBasic">
      <Link href={href} onClick={handleConfiguratorClick} className="mt-CardConfigurator-link">
        <AtomCard content={content} media={media} vertical={!isTabletOrWider} />
      </Link>
    </div>
  )
}

CardConfigurator.displayName = 'CardConfigurator'
CardConfigurator.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  priceFrom: PropTypes.string.isRequired,
  onConfiguratorClick: PropTypes.func,
  href: PropTypes.string.isRequired,
  linkFactory: PropTypes.func
}
